/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MeasurementUnit = "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "CM" | "IN" | "%future added value";
export type SbSharedRefineMenuDimensionUnitRadioSelect_user = {
    readonly serviceId: string | null;
    readonly profile: {
        readonly measurementUnit: MeasurementUnit | null;
    } | null;
    readonly " $refType": "SbSharedRefineMenuDimensionUnitRadioSelect_user";
};
export type SbSharedRefineMenuDimensionUnitRadioSelect_user$data = SbSharedRefineMenuDimensionUnitRadioSelect_user;
export type SbSharedRefineMenuDimensionUnitRadioSelect_user$key = {
    readonly " $data"?: SbSharedRefineMenuDimensionUnitRadioSelect_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuDimensionUnitRadioSelect_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuDimensionUnitRadioSelect_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "measurementUnit",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'fc2b7ccc2ef5138d191d7dc53da11515';
export default node;
